"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATIONS_OPTIONS = void 0;
const config_1 = require("../i18n/config");
exports.NOTIFICATIONS_OPTIONS = [
    {
        value: "all",
        label: config_1.resources.en.settings.notifications.allNotifications,
    },
    {
        value: "important",
        label: config_1.resources.en.settings.notifications.importantNotifications,
    },
    {
        value: "none",
        label: config_1.resources.en.settings.notifications.noNotifications,
    },
];
